module.exports = __webpack_public_path__ + "img/tree-02-e-trunk.97a09576.png";